import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../helpers/axiosConfig";

export const getNews = createAsyncThunk(
    'news/getNews',
    async (locale, { getState, rejectWithValue }) => {
      try {
        const { currentPage, limit } = getState().news;
        const { data } = await api.get(
          `/news?page=${currentPage}&lang=${locale}`
        );
        return {
          results: data.results,
          totalNews: data.count,
          totalPages: Math.ceil(data.count / limit)
        };
      } catch (err) {
        return rejectWithValue("Failed to fetch news");
      }
    }
  );
  

export const getNewsDetails = createAsyncThunk(
    'news/getNewsDetails',
    async ({ id }) => {
        try {
            const { data } = await api.get(`/news/${id}/`);
            return { data };
        } catch (err) {
            throw err;
        }
    }
);

export const addNewsComment = createAsyncThunk(
    'news/addNews',
    async ({ data, news_id }, { dispatch }) => {
        try {
            const res = await api.post(`/news/${news_id}/reviews/`, data);
            if (res.status === 201) {
                dispatch(getNewsDetails({ id: news_id }));
                return res.data
            }
        } catch (err) {
            throw err;
        }
    }
)
